var chunkMapping = {
	"0": [
		4648
	],
	"74": [
		5055
	],
	"150": [
		5131
	],
	"151": [
		5132
	],
	"154": [
		5135
	],
	"155": [
		5136
	],
	"156": [
		5137
	],
	"157": [
		5138
	],
	"158": [
		5139
	],
	"159": [
		5140
	],
	"160": [
		5141
	],
	"161": [
		5142
	],
	"162": [
		5143
	],
	"163": [
		5144
	],
	"164": [
		5145
	],
	"165": [
		5146
	],
	"166": [
		5147
	],
	"167": [
		5148
	],
	"168": [
		5149
	],
	"169": [
		5150
	],
	"170": [
		5151
	]
};
var idToExternalAndNameMapping = {
	"4648": [
		"default",
		"./Containers",
		3796
	],
	"5055": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5131": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5132": [
		"default",
		"./HostWrapper",
		3796
	],
	"5135": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5136": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5137": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5138": [
		"default",
		"./AuditDialog",
		3796
	],
	"5139": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5140": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5141": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5142": [
		"default",
		"./PaymentModal",
		3796
	],
	"5143": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5144": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5145": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5146": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5147": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5148": [
		"default",
		"./Challenge",
		3796
	],
	"5149": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5150": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5151": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4648": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}